export interface PostGradMicrocertificateState {
  disciplinesMicrocertificateEligibility: { [classroomId: string]: boolean };
}

const state: PostGradMicrocertificateState = {
  disciplinesMicrocertificateEligibility: {},
};

export default state;
